import { allProjects } from '@/contexts/Projects';
import { HiOutlineLink } from 'react-icons/hi';
import {
  IoLogoHtml5,
  IoLogoCss3,
  IoLogoJavascript,
  IoLogoReact,
} from 'react-icons/io5';

import { SiMaterialui, SiHeroku } from 'react-icons/si';

export default function Kulturan() {
  const kulturan = allProjects.find((element) => element.title === 'Kulturan');
  return (
    <div className='flex flex-col items-center justify-center w-full min-h-screen divide-y-2 divide-gray-900 dark:divide-white'>
      <div>
        <img
          src='https://res.cloudinary.com/arffzin/image/upload/q_auto,f_auto/v1659817655/projects/kulturan/kulturan-homepage_oqdxrk.png'
          alt={kulturan.title}
        />
      </div>
      <div className='w-full pt-8 pb-8 text-left'>
        <div className='font-sans text-xl font-bold md:text-5xl'>
          {kulturan.title}
        </div>
        <div className='mt-3 space-x-2'>
          <IoLogoHtml5 className='inline-block text-3xl' />
          <IoLogoCss3 className='inline-block text-3xl' />
          <IoLogoJavascript className='inline-block text-3xl' />
          <IoLogoReact className='inline-block text-3xl' />
          <SiMaterialui className='inline-block text-3xl' />
          <SiHeroku className='inline-block text-3xl' />
        </div>
        <p className='mt-4 font-serif text-sm md:text-base'>
          {kulturan.description}
        </p>
        <p className='mt-3 font-serif'>
          <a href={kulturan.livesite} target='blank'>
            <HiOutlineLink className='inline-block text-xl' /> Live Site
          </a>
        </p>
      </div>
    </div>
  );
}
